var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"create_item_wrap"},[_c('item-register-component',{attrs:{"item-key":_vm.itemKey}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }